$(function () {
	$(".question").click(function() {
		var selector = "#answer_"+$(this).data('question-id');
		$(selector).toggle('fast', 'swing');
	})
});